export default __webpack_public_path__ + "static/unified-folders-69d629c58c48990a46c4a8b3f6a0c1ab.webp";